async function devtricker_process_perform_logout() {
    try {
        devtricker_dom_set_showSpinnerOnUserImage();
        await devtricker_ajax_post_perform_logout();
        sessionStorage.clear();
        window.location.reload();

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}